<template>
  <div class="KintaiTodokeShusei">
    <el-dialog :title="dialogTitle" :visible="shuseiDialogVisible" @open="onOpen" @close="onClose" width="700px" top="6vh">
      <el-form :model="form" id="kintaiTodokeShuseiForm" label-width="80px" ref="kintaiTodokeShuseiForm" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item v-if="form.kintaiTodokeBango" label="提出日" prop="teishutsubi">
              {{ form.teishutsubi }}
            </el-form-item>
            <el-form-item v-if="form.kintaiTodokeBango" label="状況" prop="jokyoKubunMei">
              {{ form.jokyoKubunMei }}
            </el-form-item>
            <el-form-item label="氏名" prop="shainShimei">
              {{ form.shainShimei }}
            </el-form-item>
            <el-form-item label="休暇区分" prop="kimmuKubun">
              <select v-model="form.kimmuKubun" id="kimmuKubunSelect" @change="onChangeKubun">
                <option v-for="kubun in kimmuKubuns" :key="kubun.value" :value="kubun.value">{{ kubun.label }}</option>
              </select>
            </el-form-item>
            <el-form-item label="雇用形態" prop="koyoKeitai">
              <select v-model="form.koyoKeitai" id="koyoKeitaiSelect">
                <option v-for="kubun in koyoKeitais" :key="kubun.label" :value="kubun.label">{{ kubun.label }}</option>
              </select>
            </el-form-item>
            <el-form-item label="届出" prop="todokedeKubun">
              <select v-model="form.todokedeKubun" id="todokedeKubunSelect">
                <option v-for="kubun in todokedeKubuns" :key="kubun.label" :value="kubun.label">{{ kubun.label }}</option>
              </select>
            </el-form-item>
            <el-form-item label="電話番号" prop="denwaBango">
              <el-input v-model="form.denwaBango"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="開始日" prop="kaishiBi">
              <el-date-picker v-model="form.kaishiBi" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="終了日" prop="shuryoBi">
              <el-date-picker v-model="form.shuryoBi" value-format="yyyy-MM-dd"
                :disabled="isShuryobiDisable"></el-date-picker>
            </el-form-item>
            <el-form-item label="開始時刻" prop="kaishiJikoku">
              <el-input v-model="form.kaishiJikoku" type="time"></el-input>
            </el-form-item>
            <el-form-item label="終了時刻" prop="shuryoJikoku">
              <el-input v-model="form.shuryoJikoku" type="time"></el-input>
            </el-form-item>
            <el-form-item label="合計時間" prop="gokeiJikan">
              <el-input v-model="form.gokeiJikanHour" type="number" min="0" max="200" :readonly="isReadonly" class="half-input"></el-input>時間
              <el-input v-model="form.gokeiJikanMin" type="number" min="0" max="59" :readonly="isReadonly" class="half-input"></el-input>分
            </el-form-item>
            <el-form-item label="事由" prop="jiyu">
              <el-input v-model="form.jiyu" type="textarea" rows="2"></el-input>
            </el-form-item>
            <!--
            <el-form-item label="休日出勤日" prop="kyujitsuShukinBi">
              <el-date-picker v-model="form.kyujitsuShukinBi" value-format="yyyy-MM-dd"
                :disabled="isKyujitsuShukinBiDisable"></el-date-picker>
              <div>※振替休日の場合</div>
            </el-form-item>
            -->
            <el-form-item label="備考欄" prop="biko">
              <el-input v-model="form.biko" type="textarea" rows="2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">キャンセル</el-button>
        <el-button type="primary" @click="onRegister('kintaiTodokeShuseiForm')">修正</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { notifySuccess, notifyError } from '../utils.js'

export default {
  name: 'KintaiTodokeShusei',
  props: ['shuseiDialogVisible', 'kintaiTodokeBango'],
  data() {
    return {
      form: {
        shainId: '',
        shainShimei: '',
        kintaiTodokeBango: '',
        teishutsubi: '',
        jokyoKubun: '',
        jokyoKubunMei: '',
        kimmuKubun: '',
        kimmuKubunMei: '',
        koyoKeitai: '',
        todokedeKubun: '',
        denwaBango: '',
        kaishiBi: '',
        shuryoBi: '',
        kaishiJikoku: '',
        shuryoJikoku: '',
        gokeiJikanHour: '0',
        gokeiJikanMin: '0',
        jiyu: '',
        kyujitsuShukinBi: '',
        biko: '',
        fileName: '',
      },
      errors: {
      },
      isShuryobiDisable: true,
      isUpdate: false,
      loading: true,
    }
  },
  computed: {
    dialogTitle() {
      return `勤怠届番号：${this.kintaiTodokeBango}`;
    },
    kimmuKubuns() {
      return [
        { value: '27', label: '遅刻' },
        { value: '26', label: '早退' },
        { value: '28', label: '欠勤' },
        { value: '21', label: '全日有給休暇' },
        { value: '22', label: '午前半有給休暇' },
        { value: '23', label: '午後半有給休暇' },
        { value: '31', label: '時間単位有給休暇' },
        { value: '32', label: '外出' },
        { value: '30', label: 'その他' },
      ];
    },
    koyoKeitais() {
      return [
        { label: '有期雇用（契約）' },
        { label: '有期雇用（派遣）' },
        { label: '無期雇用' },
      ];
    },
    todokedeKubuns() {
      return [
        { label: '事前' },
        { label: '事後' },
      ];
    },
  },
  methods: {
    onOpen() {
      this.loading = true;
      this.isUpdate = false;
      this.$axios.get('/gwr/kintaitodoke/get/' + this.kintaiTodokeBango)
        .then((response) => {
          const gokeiJikans = response.data.gokeiJikan?.split(':');
          this.form.shainId = response.data.shainId;
          this.form.kintaiTodokeBango = response.data.kintaiTodokeBango;
          this.form.teishutsubi = response.data.teishutsubi;
          this.form.jokyoKubun = response.data.jokyoKubun;
          this.form.jokyoKubunMei = response.data.jokyoKubunMei;
          this.form.shainShimei = response.data.shainShimei;
          this.form.kimmuKubun = response.data.kimmuKubun;
          this.form.kimmuKubunMei = response.data.kimmuKubunMei;
          this.form.koyoKeitai = response.data.koyoKeitai;
          this.form.todokedeKubun = response.data.todokedeKubun;
          this.form.denwaBango = response.data.denwaBango;
          this.form.kaishiBi = response.data.kaishiBi;
          this.form.shuryoBi = response.data.shuryoBi;
          this.form.kaishiJikoku = response.data.kaishiJikoku;
          this.form.shuryoJikoku = response.data.shuryoJikoku;
          this.form.gokeiJikanHour = gokeiJikans?.[0];
          this.form.gokeiJikanMin = gokeiJikans?.[1];
          this.form.jiyu = response.data.jiyu;
          this.form.kyujitsuShukinBi = response.data.kyujitsuShukinBi;
          this.form.biko = response.data.biko;
          this.form.fileName = response.data.fileName;
          this.isShuryobiDisable = (this.form.kimmuKubun != "21" && this.form.kimmuKubun != "28" && this.form.kimmuKubun != "30");
          this.loading = false;
        })
        .catch((error) => {
          notifyError(this, error, 'データ取得エラー');
        });
    },
    onChangeKubun(e) {
      const val = e.target.value;
      this.isShuryobiDisable = (val != "21" && val != "28" && val != "30")
    },
    onRegister(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const kimmuKubunMei = this.kimmuKubuns.find((e) => e.value == this.form.kimmuKubun)?.label ?? '';
          this.$confirm(this.form.kaishiBi + '（' + kimmuKubunMei + '）の勤怠届を修正します。よろしいですか？', '確認', {
            confirmButtonText: 'はい',
            cancelButtonText: 'キャンセル',
            type: 'info'
          }).then(() => {
            this.loading = true;
            const gokeiJikan = this.form.gokeiJikanHour.padStart(2, '0') + ':' + this.form.gokeiJikanMin.padStart(2, '0');
            const formData = new FormData();
            formData.append('kintaiTodokeBango', this.form.kintaiTodokeBango ?? '');
            formData.append('shainId', this.form.shainId ?? '');
            formData.append('teishutsubi', this.form.teishutsubi ?? '');
            formData.append('jokyoKubun', this.form.jokyoKubun ?? '');
            formData.append('jokyoKubunMei', this.form.jokyoKubunMei ?? '');
            formData.append('kimmuKubun', this.form.kimmuKubun ?? '');
            formData.append('kimmuKubunMei', kimmuKubunMei);
            formData.append('koyoKeitai', this.form.koyoKeitai ?? '');
            formData.append('todokedeKubun', this.form.todokedeKubun ?? '');
            formData.append('denwaBango', this.form.denwaBango ?? '');
            formData.append('kaishiBi', this.form.kaishiBi ?? '');
            formData.append('shuryoBi', this.form.shuryoBi ?? '');
            formData.append('kaishiJikoku', this.form.kaishiJikoku ?? '');
            formData.append('shuryoJikoku', this.form.shuryoJikoku ?? '');
            formData.append('gokeiJikan', gokeiJikan);
            formData.append('jiyu', this.form.jiyu ?? '');
            formData.append('kyujitsuShukinBi', this.form.kyujitsuShukinBi ?? '');
            formData.append('biko', this.form.biko ?? '');

            this.$axios.post('/gwr/kintaitodoke/shusei', formData)
              .then(() => {
                notifySuccess(this, '登録完了', '勤怠届を修正しました。');
                this.isUpdate = true;
                this.onClose();
              })
              .catch((error) => {
                notifyError(this, error, '登録エラー', '', true);
              });
          });
        } else {
          return false;
        }
      });
    },
    onClose() {
      this.$emit('close-shusei-dialog', this.isUpdate);
    }
  }
}
</script>

<style scoped>
#kintaiTodokeShuseiForm >>> .el-input {
  width: 220px !important;
}
.el-button {
  margin: 0px 1px !important;
}
#kintaiTodokeShuseiForm >>> .half-input {
  width: 80px !important;
}
#kintaiTodokeShuseiForm >>> .el-input__inner {
  font-family: inherit !important;
}
.KintaiTodokeShusei >>> .el-dialog__body {
  padding-top: 10px !important;
  padding-bottom: 0 !important;
}
.KintaiTodokeShusei >>> .el-dialog__footer {
  margin-top: -10px !important;
}

#selected,
#kimmuKubunSelect,
#koyoKeitaiSelect,
#todokedeKubunSelect {
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
  font-size: 14px;
  height: 36px;
  line-height: 50px;
  color: #606266;
  background-color: #FFFFFF;
  border-color: #DCDFE6;
  border-style: solid;
  border-radius: 4px;
  border-width: 1px;
  padding: 2px;
}

.el-form-item {
  text-align: left;
}

.el-input {
  width: 135px !important;
}

.wide-input {
  width: 215px !important;
}

.narrow-input {
  width: 60px !important;
}

.el-date-editor {
  width: 135px !important;
}

.el-input-number {
  width: 135px !important;
}

.link {
  overflow-wrap: break-word;
}

</style>